/**
 * Transition classes used throughout the application.
 * Import these instead of using hardcoded transition classes.
 */

export const transitions = {
  // All property transitions
  all: "transition-all-standard",
  allDuration: "transition-all duration-300",
  // Color transitions
  colors: "transition-colors-standard",

  // Common combinations
  colorsDuration: "transition-colors duration-150",

  // Opacity transitions
  opacity: "transition-opacity-standard",

  // Transform transitions
  transform: "transition-transform-standard",
} as const;

// Type for transition keys
export type TransitionKey = keyof typeof transitions;

// For easier usage in string concatenation
export const TRANSITION_COLORS = transitions.colors;
export const TRANSITION_ALL = transitions.all;
export const TRANSITION_TRANSFORM = transitions.transform;
export const TRANSITION_OPACITY = transitions.opacity;
